import React from 'react';
import { Mail, Phone, MapPin, Instagram } from 'lucide-react';
import { mockData } from '../mockData';
import { scrollToSection } from '../lib/scroll';

const footerLinks = {
  services: [
    'Direito Migratório',
    'Direito Penal',
    'Direito Comercial',
    'Direito do Trabalho',
    'Direito da Família',
    'Recuperação de Créditos'
  ],
  legal: [
    'Política de Privacidade',
    'Termos e Condições',
    'Proteção de Dados',
    'Livro de Reclamações'
  ],
  quickLinks: [
    { name: 'Sobre Nós', id: 'about' },
    { name: 'Nossa Equipa', id: 'team' },
    { name: 'Testemunhos', id: 'testimonials' },
    { name: 'Contactos', id: 'contact' }
  ]
};

const FooterBrand = () => (
  <div className="lg:col-span-1 space-y-6">
    <div className="flex items-center space-x-3">
      <img
        src={mockData.company.logoUrl}
        alt="Barros & Durães Advogados"
        className="w-12 h-12 object-contain"
      />
      <div>
        <div className="font-serif text-xl font-bold">Barros & Durães</div>
        <div className="text-white/70 text-xs uppercase tracking-wider">Advogados</div>
      </div>
    </div>
    <p className="text-white/70 leading-relaxed">
      Acompanhamento jurídico claro, próximo e seguro, orientado para a resolução eficaz das questões dos nossos clientes.
    </p>
    <div className="flex space-x-4">
      <a
        href="https://www.instagram.com/barrosduraesadv/"
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 bg-white/10 hover:bg-gold rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
        aria-label="Instagram"
        data-testid="footer-instagram-link"
      >
        <Instagram className="w-5 h-5" />
      </a>
    </div>
  </div>
);

const FooterServices = () => (
  <div className="space-y-6">
    <h3 className="font-serif text-lg font-bold text-gold">Áreas de Atuação</h3>
    <ul className="space-y-3">
      {footerLinks.services.map((service) => (
        <li key={service}>
          <button
            onClick={() => scrollToSection('services')}
            className="text-white/70 hover:text-gold transition-colors duration-200 text-sm"
          >
            {service}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

const FooterQuickLinks = () => (
  <div className="space-y-6">
    <h3 className="font-serif text-lg font-bold text-gold">Links Úteis</h3>
    <ul className="space-y-3">
      {footerLinks.quickLinks.map((link) => (
        <li key={link.id}>
          <button
            onClick={() => scrollToSection(link.id)}
            className="text-white/70 hover:text-gold transition-colors duration-200 text-sm"
          >
            {link.name}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div className="space-y-6">
    <h3 className="font-serif text-lg font-bold text-gold">Contactos</h3>
    <ul className="space-y-4">
      <li className="flex items-start space-x-3">
        <MapPin className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
        <span className="text-white/70 text-sm leading-relaxed">
          {mockData.company.address}
        </span>
      </li>
      <li className="flex items-start space-x-3">
        <Mail className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
        <a
          href={`mailto:${mockData.company.email}`}
          className="text-white/70 hover:text-gold transition-colors text-sm"
        >
          {mockData.company.email}
        </a>
      </li>
      <li className="flex items-start space-x-3">
        <Phone className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
        <div className="text-white/70 text-sm space-y-1">
          <div>{mockData.team[0].phone}</div>
          <div>{mockData.team[1].phone}</div>
        </div>
      </li>
    </ul>
  </div>
);

const FooterBottom = ({ currentYear }) => (
  <div className="border-t border-white/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
        <div className="text-white/60 text-sm text-center md:text-left">
          © {currentYear} Barros & Durães Advogados. Todos os direitos reservados.
        </div>
        <div className="flex flex-wrap justify-center gap-6 text-sm">
          {footerLinks.legal.map((link) => (
            <a
              key={link}
              href="#"
              className="text-white/60 hover:text-gold transition-colors duration-200"
            >
              {link}
            </a>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <FooterBrand />
          <FooterServices />
          <FooterQuickLinks />
          <FooterContact />
        </div>
      </div>
      <FooterBottom currentYear={currentYear} />
    </footer>
  );
};

export default Footer;
